/**
 * Sorts products by buyable status.
 */
export const sortProducts = (products) => [...products].sort((a, b) => {
    if (a.buyable && !b.buyable)
        return -1;
    if (!a.buyable && b.buyable)
        return 1;
    return 0;
});
export const STOREFRONT_STRATEGIES = {
    peakdeals: {
        strategy: 'PEAK_DEALS',
        validCategories: [
            'electronics',
            'home',
            'kitchen',
            'mensApparel',
            'topDeals',
            'toys',
            'womensApparel',
            'under50',
            'forYou',
        ],
    },
    topfinds: {
        strategy: 'TOP_FINDS',
        validCategories: ['beauty', 'home', 'kitchen', 'mensFashion', 'pets', 'topFinds', 'womensFashion', 'staffPicks'],
    },
    halloween: {
        strategy: 'HALLOWEEN',
        validCategories: ['adultCostumes', 'childCostumes', 'petCostumes', 'homeDecor'],
    },
};
/**
 * Storefront ID to UUID mapping.
 */
export const STOREFRONTS = {
    defaultStorefront: '616d5a4d-5940-44e7-904a-f5d82d4ec8d5',
    jorpanda: '14c557ec-6ec1-43ae-b9de-f1173cb9d59b',
    kimxbeats: '99959a4b-4689-4865-8344-e3f19d6d31d2',
    denonxkaty: '707c8855-5c4b-455c-a224-7273b01608de',
    shopmodernmoments: '6c20bba0-002d-49cf-a4bb-0098067ab407',
    shopvsfs: '15303bc1-717e-4435-95a4-a78eadd2336c',
    beatsxkimpill: '3837f471-f1b3-4d18-b46a-2481eb4ab819',
    shopoura: '60c4f668-4124-43e3-aa5b-8390651261cd',
    smegshop: '802c276b-7ce0-4f41-ab21-5fd2381d02ff',
    redonebylg: 'c2f6016f-c742-4128-a077-468632c155bd',
    mariahcareyxmas: 'ba524349-21a5-4294-a6db-494171bb0fc5',
    shopparishilton: '78bb5baa-a455-4fe7-88b7-5b75f12401a3',
    ollywellness: 'd2791429-67cb-4141-91d4-7f638768fee6',
    dove: '9d198e9b-ad4f-4834-806b-5005b29806d1',
    halloween: '2e6b4d41-5739-4203-82cf-21f5e64a0f79',
    topfinds: '69d54adc-15ba-45b5-ba9b-01f5a63818ca',
    peakdeals: 'e395ce21-d56b-4a8c-bf64-7b9622f36e2b',
};
